import React, { Component, useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import { formatMoney } from "@shopify/theme-currency";
import { useCartUpdate } from "@src/hooks";
import { useMount } from "ahooks";

const CartLineItem = ({ product }) => {
  const queryClient = useQueryClient();
  const ctx = window.theme_app;
  const [quantity, setQuantity] = useState();
  const hasProperties = Object.keys(product.properties || {}).length > 0;
  const updateCart = useCartUpdate();

  useEffect(() => {
    setQuantity(product.quantity);
  }, [product.quantity]);

  const handleCartRemoval = () => {
    const { systemCart } = window.theme_app.getState();
    var removeIds = [];
    removeIds.push(product.variant_id);
    let payload = {};
    removeIds.forEach((element) => (payload[element] = 0));
    updateCart
      .mutateAsync({ updates: payload })
      .then((response) => ctx.emit("cart.update", response.data));
  };

  const handleQuantityUpdate = (newQuantity) => {
    updateCart
      .mutateAsync({ updates: { [product.variant_id]: newQuantity } })
      .then((response) => {
        ctx.emit("cart.update", response.data);
        queryClient.invalidateQueries("cart");
      });
  };

  return (
    <div className="Card Card--cartItem">
      <figure className="Card__figure">
        <>
          {product.image && (
            <img src={product.image} alt={product.product_title} />
          )}
        </>
      </figure>
      <div className="Card__details">
        <h6 className="Card__title">
          <a
            href={
              product.product_type != "Try On" && `/products/${product.handle}`
            }
          >
            {product.product_title.split("|")[0]}
          </a>
          {!product.variant_title && (
            <small>{product.product_title.split("|")[1]}</small>
          )}
          {product.variant_title && <small>{product.variant_title}</small>}
        </h6>
        {hasProperties && (
          <dl className="product-properties">
            {Object.keys(product.properties).map((item, index) => {
              return (
                <div key={`${product.id}-${item}-${index}`}>
                  <dt>{item}:</dt>
                  <dd>{product.properties[item]}</dd>
                </div>
              );
            })}
          </dl>
        )}
        {!product.variant_title && (
          <small className="ab-test-subtitle">
            {product.product_title.split("|")[1]}
          </small>
        )}
        {product.variant_title && (
          <small className="ab-test-subtitle">{product.variant_title}</small>
        )}
        <div className="quantity_and_amount">
          <div className="amount">
            {formatMoney(product.price)}
            {quantity && product.product_type !== "Try On" && (
              <div className="qty-input">
                <span className="multiplier">x</span>
                <div className="qty-input-selector">
                  <button
                    type="button"
                    onClick={() => handleQuantityUpdate(quantity - 1)}
                  >
                    -
                  </button>
                  <span className="quantity">{quantity}</span>
                  <button
                    type="button"
                    onClick={() => handleQuantityUpdate(quantity + 1)}
                  >
                    +
                  </button>
                </div>
              </div>
            )}
          </div>

          <button
            className="Button delete-line"
            data-layout="noLayout"
            onClick={handleCartRemoval}
            aria-label="Remove"
          >
            <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
              <use href="#trash"></use>
            </svg>
          </button>
        </div>

        <div className="quantity_and_amount ab-test">
          <div className="amount">
            {formatMoney(product.price)}
            {quantity && product.product_type !== "Try On" && (
              <div className="qty-input">
                <div className="qty-input-selector">
                  <button
                    type="button"
                    onClick={() => handleQuantityUpdate(quantity - 1)}
                  >
                    -
                  </button>
                  <span className="quantity">{quantity}</span>
                  <button
                    type="button"
                    onClick={() => handleQuantityUpdate(quantity + 1)}
                  >
                    +
                  </button>
                </div>
              </div>
            )}
          </div>

          <button
            className="Button delete-line"
            data-layout="noLayout"
            onClick={handleCartRemoval}
            aria-label="Remove"
          >
            <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
              <use href="#trash-ab"></use>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartLineItem;
